/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiTokenDataFromJSON, ApiTokenDataToJSON, } from './ApiTokenData';
export function ApiRequestTokenResponseFromJSON(json) {
    return ApiRequestTokenResponseFromJSONTyped(json, false);
}
export function ApiRequestTokenResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'token': !exists(json, 'token') ? undefined : ApiTokenDataFromJSON(json['token']),
    };
}
export function ApiRequestTokenResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'token': ApiTokenDataToJSON(value.token),
    };
}
